import React from 'react'
import { ApexCharts } from '../../../../Components'
import { LogAcessoGetAcessosPorPraca } from '../../../../Service/ApiService'
import ChartCard from '../ChartCard'
import { CORES, formatarNumero, useIndicador } from '../helpers'

export default function AcessosPorPraca({ filters }) {
  const { status, data } = useIndicador(LogAcessoGetAcessosPorPraca, filters, (d) => !d.data?.length)
  const pracas = data?.labels?.map((nome) => nome || 'Sem praça') || []

  const options = {
    chart: { type: 'bar' },
    colors: [CORES.verde],
    plotOptions: { bar: { horizontal: true, barHeight: '65%', borderRadius: 3 } },
    dataLabels: { enabled: true, formatter: formatarNumero, style: { fontSize: '11px' } },
    xaxis: { categories: pracas, labels: { formatter: formatarNumero } },
    tooltip: { y: { formatter: formatarNumero } },
  }

  // Altura acompanha o número de praças para as barras não ficarem espremidas
  const altura = Math.max(280, pracas.length * 28 + 60)

  return (
    <ChartCard title="Acessos por praça" subtitle="Ordenado pelo volume de acessos" status={status}>
      <ApexCharts options={options} series={[{ name: 'Acessos', data: data?.data || [] }]} type="bar" height={altura} />
    </ChartCard>
  )
}
